import { render, staticRenderFns } from "./Ajuda.vue?vue&type=template&id=68af5154&scoped=true"
import script from "./Ajuda.vue?vue&type=script&lang=js"
export * from "./Ajuda.vue?vue&type=script&lang=js"
import style0 from "./Ajuda.vue?vue&type=style&index=0&id=68af5154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68af5154",
  null
  
)

export default component.exports